'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.fetchTranslation = fetchTranslation;

var _reduxSaga = require('redux-saga');

var _effects = require('redux-saga/effects');

var _sagaUtils = require('@wh/saga-utils');

var _dataProvider = require('@wh/data-provider');

var _languageCommon = require('@wh/language-common');

var _reduxTunnel = require('@wh/redux-tunnel');

var _reduxTunnel2 = _interopRequireDefault(_reduxTunnel);

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [fetchTranslation, watchFetchEntity].map(_regenerator2.default.mark);

/**
 * Fetch translation Saga
 * @returns {void}
 */
function fetchTranslation() {
    var lang, tunnel, data;
    return _regenerator2.default.wrap(function fetchTranslation$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return (0, _effects.select)(_languageCommon.getActiveLanguageAndCountryCode);

                case 2:
                    lang = _context.sent;
                    _context.next = 5;
                    return (0, _effects.select)(_reduxTunnel2.default);

                case 5:
                    tunnel = _context.sent;
                    _context.prev = 6;
                    _context.next = 9;
                    return (0, _effects.call)(_dataProvider.getTranslationTokenData, { lang: lang, tunnel: tunnel });

                case 9:
                    data = _context.sent;
                    _context.next = 12;
                    return (0, _effects.put)({ type: _constants.TRANSLATION_FETCH_SUCCEEDED, data: data });

                case 12:
                    _context.next = 18;
                    break;

                case 14:
                    _context.prev = 14;
                    _context.t0 = _context['catch'](6);
                    _context.next = 18;
                    return (0, _effects.put)({ type: _constants.TRANSLATION_FETCH_FAILED, error: _context.t0 });

                case 18:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked[0], this, [[6, 14]]);
}

/**
 * Saga to watch actions of type TRANSLATION_FETCH_REQUESTED
 * @returns {void}
 */
function watchFetchEntity() {
    return _regenerator2.default.wrap(function watchFetchEntity$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _effects.call)(_reduxSaga.takeLatest, _constants.TRANSLATION_FETCH_REQUESTED, fetchTranslation);

                case 2:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked[1], this);
}

exports.default = (0, _sagaUtils.setupSagaTarget)(watchFetchEntity, true, false);
//# sourceMappingURL=sagas.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/translation-tokens/dist/main/sagas.js
// module id = 539
// module chunks = 0